<mat-card-header>
  <mat-card-title>{{ title }}</mat-card-title>
  <nav class="header-actionbar">
    @if (enableFilter || enableFilterbuilder) {
      <smd-filter
        [selectedSearchScope]="selectedSearchScope"
        (selectedSearchScopeChange)="selectedSearchScope = $event; refreshSearchScope()"
        [(filterValue)]="filterValue"
        (filterChange)="_onFilter($event)"
        [title]="title"
        [searchScopeConfigs]="searchScopeConfigs"
        [enableFilter]="enableFilter"
        [enableFilterbuilder]="enableFilterbuilder"
      ></smd-filter>
    }

    @if (showExpandAllButton) {
      <button mat-icon-button (click)="expandAll()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
          <path
            d="M480-80 240-320l57-57 183 183 183-183 57 57L480-80ZM298-584l-58-56 240-240 240 240-58 56-182-182-182 182Z"
          />
        </svg>
      </button>
    }
    @if (showCollapseAllButton) {
      <button mat-icon-button (click)="collapseAll()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
          <path
            d="m296-80-56-56 240-240 240 240-56 56-184-184L296-80Zm184-504L240-824l56-56 184 184 184-184 56 56-240 240Z"
          />
        </svg>
      </button>
    }

    <button mat-icon-button class="close-icon" (click)="onCloseView.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </nav>
</mat-card-header>
<mat-card-content>
  @if (loading) {
    <div class="loader">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else if (visibleRows.length === 0) {
    <div class="noItems">
      <span><language key="EmptyList" defaultValue="No items."></language></span>
    </div>
  } @else {
    @for (row of visibleRows; track row) {
      <smd-timeline-row #timelineRow [rowModel]="row"></smd-timeline-row>
    }
  }
</mat-card-content>
<mat-card-footer>
  <div class="smd-data-table-footer">
    <!-- Using hidden because *ngIf is conflicting with ViewChild(SmdPaginatorComponent) -->
    <div [hidden]="!paginated || loading || rows.length === 0">
      <div class="footer-left">
        <language key="DatatableTotalItems" defaultValue="Total items:"></language>
        {{ formatNumber(displayedTotalCount) | async }}<br />
        @if (loadTimestamp) {
          <span>
            <language key="DatatableTimeLoaded" defaultValue="Data loaded at"></language>
            {{ loadTimestamp | localDate: 'LTS' | async }}
          </span>
        }
        <br />
        @if (showLoadingTime && loadingTime !== null) {
          <span>
            <language key="DatatableLoadingTime" defaultValue="Loading Time:"></language>
            {{ loadingTime }} ms
          </span>
        }
      </div>
      <smd-paginator (pageChange)="_onPageChange($event)"></smd-paginator>
    </div>
  </div>
</mat-card-footer>
